import { render, staticRenderFns } from "./EditPersonalDetails.vue?vue&type=template&id=70364cd9&"
import script from "./EditPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./EditPersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports